import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "scale", "breakpoints", "children"];
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import React from 'react';
import styled from 'styled-components';
import { pxToEm } from 'utils/ui/units';
import { createStyleFunction } from 'utils/ui/styleProps';
import ImageWithLoader from 'components/LazyImage/ImageWithLoader';
export var responsiveScaleProp = createStyleFunction([{
  styleProp: 'scale',
  properties: ['fontSize'],
  getValue: function getValue(value) {
    return "".concat(1 * Number(value), "rem");
  }
}]);
export var scalePresets = {
  big: {
    scale: [1.5, 2],
    breakpoints: 'm'
  }
};
/* Components */

var Wrapper = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['scale', 'breakpoints'].includes(prop);
  }
}).withConfig({
  displayName: "CircleImage__Wrapper",
  componentId: "sc-1kenrqa-0"
})(["position:relative;display:inline-block;vertical-align:middle;width:", ";height:", ";border-radius:50%;font-size:1rem;", " img{border-radius:inherit;}"], pxToEm(34), pxToEm(34), responsiveScaleProp);
function CircleImage(_ref) {
  var size = _ref.size,
    scale = _ref.scale,
    breakpoints = _ref.breakpoints,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var sizeOverrideProps = size && scalePresets[size];
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    scale: scale,
    breakpoints: breakpoints
  }, sizeOverrideProps), /*#__PURE__*/React.createElement(ImageWithLoader, otherProps), children);
}
export default CircleImage;